<template>
	<div>
	  <!-- Toast notification component -->
	  <v-snackbar
		v-model="showSnackbar"
		:color="snackbarColor"
		:timeout="3000"
		location="top"
		rounded="pill"
		elevation="4"
		class="pa-3"
	  >
		<div class="d-flex align-center">
			<v-icon class="me-3" :icon="snackbarIcon"></v-icon>
			<span class="text-subtitle-1 font-weight-medium">{{ snackbarText }}</span>
		</div>
		<template v-slot:actions>
		  <v-btn
			variant="text"
			icon="mdi-close"
			@click="showSnackbar = false"
		  ></v-btn>
		</template>
	  </v-snackbar>
  
	  <!-- Dialog component -->
	  <v-dialog v-model="dialog" width="500px">
		<v-card class="rounded-xl elevation-5">

		<v-card-title class="text-h5 bg-primary text-white rounded-t-xl py-4">
			<v-icon icon="mdi-note-plus-outline" class="me-2"></v-icon>
			{{ t('interviewcampaigndialog.addNewTopic') }}
		</v-card-title>


		  <!-- <v-toolbar color="primary" dark flat>
			<v-toolbar-title class="text-h6 font-weight-bold">
			  <v-icon start icon="mdi-note-plus-outline" class="me-2"></v-icon>
			  Add New Topic
			</v-toolbar-title>
			<v-spacer></v-spacer>
			<v-btn icon="mdi-close" @click="closeDialog" variant="text"></v-btn>
		  </v-toolbar> -->
  
		  <v-card-text class="pa-6">
        <v-select
            class="domain-select mb-4"
            :label="$t('generic.domain')"
            item-title="title"
            item-value="value"
            v-model="newSelectedDomain"
            density="default"
            variant="outlined"
            color="primary"
            prepend-inner-icon="mdi-domain"
            disabled
            hide-details
        />
			<v-text-field
			  v-model="campaignName"
			  :label="$t('interviewcampaigndialog.topicName')"
			  variant="outlined"
			  density="compact"
			  :placeholder="$t('interviewcampaigndialog.enterTopicName')"
			  clearable
			></v-text-field>
			<v-textarea
			  v-model="campaignDescription"
			  :label="$t('interviewcampaigndialog.description')"
			  variant="outlined"
			  density="compact"
			  rows="4"
			  counter="1500"
			  class="mb-3"
			  :placeholder="$t('interviewcampaigndialog.enterTopicDescriptionMax1500Characters')"
			  clearable
			></v-textarea>
		  </v-card-text>
  
		  <v-card-actions class="pa-4">
			<v-spacer></v-spacer>
			<v-btn 
			@click="closeDialog" 
			color="grey-darken-1" 
			variant="text"
			rounded="pill" 
			class="px-5"
			>
			Cancel
			</v-btn>
			<v-btn 
				@click="submit" 
				color="primary" 
				variant="elevated"  
				rounded="pill"
				class="px-5"
			>
			  <v-icon start icon="mdi-check-circle-outline" class="me-1"></v-icon> {{ t('interviewcampaigndialog.submit') }}
			</v-btn>

		  </v-card-actions>
		</v-card>
	  </v-dialog>
	</div>
  </template>
  
  <script>
  import { useI18n } from "vue-i18n";
  export default {
	name: "InterviewCampaignDialog",
	props: {
	  showDialog: {
		type: Boolean,
		required: true,
	  },
    selectedDomain: {
      type: String,
      required: true,
    }
	},
	setup() {
		const { t } = useI18n();

		return {
		t
		};
	},
	data() {
	  return {
		dialog: this.showDialog, // Controlled by parent via props
		campaignName: "", // Campaign name input
		campaignDescription: "", // Campaign description input
		
		// Toast notification state
		showSnackbar: false,
		snackbarText: "",
		snackbarColor: "error", // Default to error color (reddish)
		snackbarIcon: "mdi-alert-circle",
      newSelectedDomain: "Telco",

	  };
	},
	watch: {
	  showDialog(val) {
		this.dialog = val;
	  },
	  dialog(val) {
		this.$emit("update:showDialog", val); // Notify parent when dialog state changes
	  },
    selectedDomain(val) {
      this.newSelectedDomain = val;
    },
	},
	methods: {
	  // Show a toast notification with a message and optional type
	  showToast(message, type = "error") {
		this.snackbarText = message;
		
		// Set appropriate color and icon based on notification type
		if (type === "error") {
		  this.snackbarColor = "error"; // Reddish color for errors
		  this.snackbarIcon = "mdi-alert-circle";
		} else if (type === "success") {
		  this.snackbarColor = "success"; // Green color for success
		  this.snackbarIcon = "mdi-check-circle";
		} else if (type === "warning") {
		  this.snackbarColor = "warning"; // Amber/yellow for warnings
		  this.snackbarIcon = "mdi-alert";
		} else if (type === "info") {
		  this.snackbarColor = "info"; // Blue color for information
		  this.snackbarIcon = "mdi-information";
		}
		
		this.showSnackbar = true;
	  },
	  
	  closeDialog() {
		this.dialog = false; // Close the dialog
	  },
	  
	  submit() {
		// Validate inputs
		if (!this.campaignName || !this.campaignDescription) {
		  this.showToast(this.$t('interviewcampaigndialog.pleaseFillInAllFields'));
		  return;
		}
		
		// Emit the form data to the parent
		this.$emit("submit", {
		  campaign_name: this.campaignName,
		  description: this.campaignDescription,
      selectedDomain: this.newSelectedDomain
		});
		
		this.dialog = false; // Close the dialog
	  },
	},
  };
  </script>